module.exports = __webpack_public_path__ + "assets/firebase.7f90d0ba.svg";